<template>
    <div class="liquor">
        <div class="view_one">
            <img class="view_one_img" src="https://cdn.zxzx119.com/zxzx-h5/liquor/party01.png" alt="" srcset="">
            <img class="view_two_img" src="../../assets/images/liquor/party02.png" @click="clickComm" alt=""
                srcset="">
        </div>
        <div class="view_two">
            <div class="view_two_comm">
                <div class="view_comm_title">
                    <div>中消商城购买商品满<span>3</span>万元,</div>
                    <div>即可购买价值<span>1499</span>元茅台酒！</div>
                </div>
                <div class="view_two_text">
                    活动主题：中消商城 双旦·年货节<br/>
                    活动时间：2022.12.25-2023.01.13<br/><br/>
                    <strong>活动简介</strong><br/>
                    &ensp;&ensp;本次双旦·年货节活动12月25日正式开始，为回馈新老用户的支持，特此为满足活动条件的用户提供超低价购买茅台酒等购买资格，数量有限先来先得！<br/>
                    <br/><strong>活动规则</strong><br/>
                    任务目标：用户每购买满3万元<br/>
                    活动奖励：将获得一次活动领取优惠券资格，无上限<br/>
                    有效订单：用户在商城购买除酒类的其他商品均为有效订单<br/><br/>
                     <strong>好友助力说明</strong><br/>
                    绑定关系：通过您分享的链接邀请的所有好友成功注册后会显示在您的助力列表中<br/>
                    共享1万元助力金额：所有好友的订单综合为您的助力金额，最高共享1万元<br/>
                    成交金额：当前下单的金额<br/>
                    实际金额：订单购买15日后算做为实际金额<br/>
                    助力订单生效规则:2023年1月13日前购买，并在2023年1月28日前生效为实际金额的订单为有效订单<br/><br/>
                    <strong>优惠券</strong><br/>
                    优惠券类型：本次发放的直购券，用户可通过使用直购券直接以优惠价格购买商品<br/>
                    领取方式：自己购买和所邀用户购买的实际购买总额大于3万（含好友共享最高1万元）元即可领取，累计超过6万（含好友共享最高1万元）元可以领取第二次，以此类推，无上限<br/>
                    生效日期：优惠券领取15日后生效<br/>
                    使用有效期：优惠券生效后30日内有效<br/><br/>
                   
                    <strong>本次活动规则解释权归中消商城所有</strong><br/>


                </div>
            </div>
            <!-- <img class="view_two_img" src="../../assets/images/liquor/party03.png" alt="" srcset=""> -->
        </div>
        <div class="user_register">
            <van-overlay :show="show" @click="show = false">
                <div class="wrapper" @click.stop>
                    <div class="block">
                        <div class="block_title">
                            注册并领取
                        </div>
                        <div class="block_form">
                            <van-cell-group inset class="block_form_one">
                                <van-field v-model="tel" type="number" maxlength="11" center clearable label="手机号" placeholder="请输入手机号">
                                </van-field>
                            </van-cell-group>
                            <van-cell-group inset>
                                <van-field v-model="sms" maxlength="6" center clearable label="验证码" placeholder="请输入验证码">
                                    <template #button>
                                        <van-button v-show="buttonShow == 0" class="field_button" size="small"
                                            @click="getcode">获取验证码</van-button>
                                        <van-button v-show="buttonShow == 1" class="field_button field_button_active"
                                            size="small">{{ count }}s后重新获取</van-button>
                                        <van-button v-show="buttonShow == 2" class="field_button" size="small"
                                            @click="getcode">重新获取</van-button>
                                    </template>
                                </van-field>
                            </van-cell-group>
                            <div class="form_error">
                                <p v-show="errorShow">
                                    <van-icon name="warning-o" size='16px' /><span>{{ error }}</span>
                                </p>
                            </div>
                            <van-radio-group v-model="checked" icon-size="18px" class="xieyi">
                                <van-radio name="1" checked-color="#C41335">勾选同意<span
                                        @click.stop="gotoUrl">《中消商城平台服务协议》</span></van-radio>
                            </van-radio-group>
                            <div class="register_btn" @click="register">
                                立即注册
                            </div>
                        </div>
                        <div class="close_tag" @click="show = false">
                            <van-icon name="clear" size="30px" color="#AEAEAE" />
                        </div>
                    </div>
                </div>
            </van-overlay>
            <van-overlay :show="showTwo" @click="showTwo = false">
                <div class="wrapper wrapper_two" @click.stop>
                    <div class="block">
                        <div class="block_form">
                            <img src="./../../assets/images/liquor/qr_code.png" alt="" srcset="">
                            <p>扫一扫立即了解</p>
                        </div>
                        <div class="close_tag" @click="showTwo = false">
                            <van-icon name="clear" size="30px" color="#AEAEAE" />
                        </div>
                    </div>
                </div>
            </van-overlay>
        </div>

    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import Axios from 'axios'
import QS from 'qs'
import wxShare from '../../wx/weixin.js'
export default {
    name: '',
    components: {
    },
    data() {
        return {
            show: false,
            showTwo : false,
            buttonShow: 0,
            checked: false,
            error: '请输入正确的手机号!',
            errorShow: false,
            time: null,
            count: "",
            tel: "",
            sms: '',
            inviteId: '',
            accessToken: '',
            userInfo: "",
            openId: "",
            unionid: '',
            isUser: false,
            loadNum : 0
            
        }
    },
    created() {
        this.inviteId = this.$route.query.inviteId
        let code = this.GetParam(window.location.href, "code");
        // let localUnionid = localStorage.setItem('zxzxmallunionid',"")
        if (!code) {
            this.toWx()
        } else {
            this.getAccessTokenWx(code)
        }
        
    },
    methods: {
        clickComm() { 
            if (this.isUser) {
                // Toast("你已注册请到中消商城APP查看")
                this.showTwo = true
            } else { 
                this.show = true
            }
        },
        register() {
            if (this.tel==""||!this.utils.isPhone(this.tel)) {
                this.error = "请填写正确的手机号";
                this.errorShow = true;
                return false
            } else if (this.sms=="") {
                this.error = "请填写正确的验证码";
                this.errorShow = true;
                return false
            } else if (!this.checked) {
                this.error = "请勾选同意协议";
                this.errorShow = true;
                return false
            }
            let params = {
                phone: this.tel,
                code: this.sms,
                invite_id: this.inviteId,
                nick_name: this.userInfo.nickname,
                user_img: this.userInfo.headimgurl,
                openid: this.openId,
                unionid : this.unionid
            }
            Axios({
                method: 'post',
                url: this.accountUrl + "/account/registerForAct",
                data: QS.stringify(params),
            }).then(response => {
                let data = response.data
                if (data.code === 0) { 
                    Toast("注册成功");
                    this.show = false;
                    setTimeout(() => {
                        this.showTwo = true;
                    },1000)
                } else if (data.message=="该手机号已注册") {
                    Toast("你已注册");
                    this.show = false;
                    setTimeout(() => {
                        this.showTwo = true;
                    },1000)
                }else{
                    Toast(data.message);
                }
            })

        },
        getAccessTokenWx(code) {
            let that = this
            this.utils.get(this.accountUrl + '/actUserRelation/getAccessToken?code=' + code, null, res => {
                console.log(res)
                if (res.success) {
                    that.accessToken = res.data.access_token;
                    that.openId = res.data.openid;
                    that.unionid = res.data.unionid;
                    that.getUserInfo()
                    that.loadShareInfo();
                } else {
                    if (this.loadNum > 4) {
                        Toast("系统报错")
                        return false
                    } else {
                        window.open(window.location.origin + window.location.pathname + "?inviteId=" + this.inviteId)
                    }
                }
            })
        },
        loadShareInfo() { 
            let shareUrl = window.location.origin + window.location.pathname + "?inviteId=" + this.inviteId
            wxShare.wxShareMall("【中消商城】飞天茅台最低1499元","中消商城APP正式上线，低至1499元飞天茅台，赶快喊你的朋友来看看！","https://cdn.zxzx119.com/1551752508827762688",shareUrl)
        },
        getUserInfo() {
            this.utils.get(this.accountUrl + '/actUserRelation/getUserInfo?access_token=' + this.accessToken + '&openid=' + this.openId, null, res => {
                console.log(res)
                if (res.success) {
                    this.userInfo = res.data;
                    this.checkUserExist()
                }
            })
            
        },
        checkUserExist() {
            this.utils.get(this.accountUrl + '/actUserRelation/checkUserExist?unionid=' + this.unionid , null, res => {
                console.log(res)
                if (res.success) {
                    this.isUser = res.data;
                    // if (this.isUser) {
                    //     Toast("你已经注册请到中消商城APP查")
                    // }
                }
            })
        },
        //拿到微信code
        async toWx() {
            // 授权回调
            let local = window.location.href;
            // let local = window.location.href.split("#")[0];
            let url =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appIdMall+"&redirect_uri=" +
                encodeURIComponent(local) +
                "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            console.log("window.location.href", window.location.href);
            let code = this.GetParam(window.location.href.split("#")[0], "code");
            if (!code) {
                window.location.href = url;
                console.log("code", code);
            } else {
                this.code = this.GetParam(window.location.href, "code");
                console.log("code", code);
            }
        },
        // 截取code
        GetParam(url, code) {
            url = url + "";
            let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
            let reg = eval(regstr);
            //eval可以将 regstr字符串转换为 正则表达式
            let result = url.match(reg);
            if (result && result[2]) {
                return result[2];
            }
        },
        getSendsms() { 
            this.utils.POST(this.accountUrl + '/account/sendsms', { phone: this.tel }, function (response) {
                console.log('========短信发送成功')
                if (parseInt(response.code) === 0) {
                    Toast('短信已发送成功')
                }
            })
        },

        getcode() {
            if (!this.utils.isPhone(this.tel)) { 
               this.error = "请填写正确的手机号";
                this.errorShow = true;
                return false
            }
            const times = 60; // 倒计时时间
            if (!this.timer) {
                this.getSendsms()
                this.count = times;
                this.buttonShow = 1;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= times) {
                        this.count--;
                    } else {
                        this.buttonShow = 2;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        gotoUrl() {
            window.open("https://app.zxzx119.com/recruit/#/service")
        }
    },
    mounted() {

    },
}

</script>

<style lang="scss">
.liquor {
    .van-field__label {
        width: 60px;
    }

    .van-cell-group--inset {
        height: 55px;
        margin: 0;
    }

    .van-cell {
        padding: 10px 0px;
    }
}
</style>
<style lang='scss' scoped>
.liquor {
    margin: 0;
    padding: 0;

    .user_register {
        .wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .block {
            width: 345px;
            height: 320px;
            background-color: #fff;
            border-radius: 6px;
            position: relative;

            .close_tag {
                position: absolute;
                bottom: -60px;
                left: calc(50% - 15px);
            }

            .register_btn {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                background: #C41335;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                margin-top: 10px;
            }

            .xieyi {
                font-size: 12px;
                color: #888;

                span {
                    color: #C41335;
                }
            }

            .form_error {
                height: 23px;
                width: 100%;
                margin: 10px 0;

                p {
                    background: #FFFCCC;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #FF0000;
                    padding-left: 10px;

                    span {
                        padding-left: 5px;
                    }
                }

            }

            .block_title {
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(196, 19, 53, 1);
                color: #FFFDFD;
                font-size: 18px;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
            }

            .block_form {
                margin: 0 20px;

                .block_form_one {
                    margin-top: 20px;
                    // padding-bottom: 15px;
                }

                .block_form_one:after {
                    border-top: 0 solid #ebedf0;
                }
            }

            .field_button {
                color: rgba(196, 19, 53, 1);
                // font-size: 14px;
                border: 0px solid #fff;
            }

            .field_button_active {
                color: #888
            }

            .field_button:active {
                background: #fff;
            }
        }
        .wrapper_two {
            .block{
                width: 200px;
                height: 230px;
                .block_form{
                    margin: 15px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    p{
                        text-align: center;
                        font-size: 16px;
                    }
                }
                
            }
        }
    }

    .view_one {
        position: relative;

        .view_one_img,
        .view_two_img {
            width: 100%;
            display: block;
        }

        .view_two_img {
            // position: absolute;
            background: #C73546;
            width: 100%;
            margin-top: -100px;
            
        }
    }

    .view_two {
        background: #C73546;
        padding: 28px 20px 30px 20px;
        margin-top: -2px;

        .view_two_comm {
            height: 371px;
            background: url("../../assets/images/liquor/party03.png") no-repeat;
            background-size: 100% 100%;
            padding: 30px 15px 10px 15px;

            .view_comm_title {
                font-size: 16px;
                font-weight: bold;
                color: #C41335;
                border-bottom: 1px dashed #9D9FA7;
                padding-bottom: 8px;
                text-align: center;

                >div:first-child {
                    margin: 5px 0 -10px 0;
                }

                span {
                    font-size: 24px;
                }
            }

            .view_two_text {
                margin-top: 15px;
                height: 230px;
                word-wrap: break-word;
                font-size: 14px;
                color: #222;
                font-weight: 400;
                overflow: hidden;
                overflow-y: auto;
            }

        }

        .view_two_img {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/liquor/index.vue